<template>
  <div v-if="params.value !== undefined" class="ag-table-cell-value-wrapper">
    <div class="ag-table-cell-value ag-table-not-commissioned-device-type-renderer-wrapper">
      <div v-for="device in params.no_devices_list.sort((a, b) => a - b)" :key="device"
           class="ag-table-not-commissioned-device-type-renderer">
        <div class="ag-table-not-commissioned-device-type-renderer__icon">
          <app-icon :name="getType(device).icon"
                    :key="getType(device).icon"
                    :style="{color: `rgba(var(--app-${getType(device).icon_color}), 1)`}" size="18px"/>
        </div>
        <div class="ag-table-not-commissioned-device-type-renderer__title">{{getType(device).name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';

  export default Vue.extend({
    name: "NotCommissionedTypesRenderer",
    methods: {
      getType(typeId) {
        return this.$store.getters['common/devices/typeById'](typeId);
      },
    }
  })
</script>

<style lang="scss">
  .ag-table-not-commissioned-device-type-renderer-wrapper {
    flex-wrap: wrap;
  }

  .ag-table-not-commissioned-device-type-renderer {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    & + & {
      &:before {
        content: " | ";
        margin-left: 5px;
      }
    }

    &__icon {
      flex-shrink: 0;
      margin-right: .5rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__title {
      text-align: left;
      line-height: 1.1;
      white-space: nowrap;
    }
  }
</style>
